<div class="create-simulation-page">
  <!-- <qai-inner-wrap> -->
  <!-- HEADER -->
  <header *ngIf="!loading" class="page-header">
    <!-- Row 1: Breadcrumbs & Actions -->
    <div class="header-row-one">
      <div class="breadcrumb-container">
        <qai-breadcrumb-list
          [items]="[
            {
              text: 'Simulations',
              href: '/self-serve?fromSimulationDetails=true'
            },
            {
              text: simulationName,
              active: true
            }
          ]"
        ></qai-breadcrumb-list>
      </div>

      <div class="header-actions">
        <span class="header-label">
          Last saved: {{ (callType === 'Knowledge check' ? simulationDetails?.updatedAt : lastSaved) | date : 'h:mma, MMMM d, y' }}
        </span>

        <ng-container *ngIf="callType !== 'Knowledge check'">
        <button
          *ngIf="readOnly === false"
          qai-button
          size="medium"
          kind="primary"
          [disabled]="!readyForPublish || readOnly"
          (click)="publishSimulation()"
        >
          Publish simulation
        </button>
        <qai-kebab-menu
          [items]="options"
          (itemClicked)="onKebabMenuAction($event)"
          [placement]="'below-start'"
          [size]="'24px'"
        ></qai-kebab-menu>
        </ng-container>
      </div>
    </div>

    <div *ngIf="callType !== 'Knowledge check'">
      <!-- Row 2: Tabs -->
      <div class="header-row-two">
        <qai-tabs>
          <ng-template qaiTab="uniqueId1" label="General">
            <tab-general-content></tab-general-content>
          </ng-template>

          <ng-template qaiTab="uniqueId2" label="Contents">
            <tab-content-details></tab-content-details>
          </ng-template>

          <ng-template *ngIf="showKeyWordsTab" qaiTab="uniqueId3" label="Key Words">
            <tab-key-words-details></tab-key-words-details>
          </ng-template>

          <ng-template qaiTab="uniqueId4" label="Scoring">
            <tab-scoring-details></tab-scoring-details>
          </ng-template>

          <ng-template qaiTab="uniqueId5" label="Testing">
            <tab-testing-details></tab-testing-details>
          </ng-template>
        </qai-tabs>
      </div>
    </div>
  </header>

  <div *ngIf="callType === 'Knowledge check' && simulationDetails">
    <guided-simulation-details [simulationDetails]="simulationDetails"></guided-simulation-details>
  </div>
</div>

<delete-modal
  [open]="isDeleteModalOpen"
  (openChange)="isDeleteModalOpen = $event"
  (confirm)="confirmDelete()"
  (closeModal)="isDeleteModalOpen = false"
  [networkRequestInProgress]="networkRequestInProgress"
  [type]="EntityType.SIMULATION"
>

</delete-modal>

<action-modal
  [open]="duplicateModalVisible"
  [entityType]="EntityType.SIMULATION"
  [entityActionType]="EntityActionType.DUPLICATE"
  [originalName]="simulationToDuplicateName"
  [networkRequestInProgress]="networkRequestInProgress"
  [errorStatus]="modalErrorStatus"
  (confirmAction)="onSimulationDuplicated($event)"
  (closeModal)="closeDuplicateModal()"
></action-modal>

<publish-simulation-modal
  [open]="openPublishModal"
  (confirm)="handlePublishModalConfirm()"
  (closeModal)="handlePublishModalClose()"
></publish-simulation-modal>
